import {StorageUtil} from './Auth.js';
import {CommonUtil} from './CommonUtil.js';
import {store} from '../store/store';

//var baseUrl= 'http://localhost:8080';//本地测试
var baseUrl= 'http://119.23.205.178:8081';//外网测试
var ajaxUtil = {

    /**
     * 发送ajax请求，content-type: application/json
     * @param url     -rest api url    可以带参数
     * @param data    -提交的json数据  放入body中，如果无可以传空
     * @param method  - http请求类型
     * @param successCallback -请求成功后的处理方法  如果传空，默认弹出请求成功的弹出框提示
     * @param failCallback    -请求失败后的处理方法  如果传空，默认弹出异常message的弹出框提示
     * @param thisStr:请求页面的this
     */
    ajaxJson: async function (url, data, method, successCallback, failCallback, thisStr) {
       // var baseUrl = 'http://' + location.host;
        let baseUrl = document.location.protocol+"//" + window.location.host;
        //登录超时判断
        this.overtimeLogin();
        await thisStr.axios({
            baseURL: baseUrl,
            url: encodeURI(url),
            method: method,
            data: JSON.stringify(data),
            responseType: 'json',
            timeout: 60000,
            headers: {
                token: store.func.getToken(),
                'Content-Type': 'application/json; charset=UTF-8',
                 regCode: StorageUtil.getString("regCode")||'',              
                 postTime:StorageUtil.getString("postTime")||'', 
            }
        })
            .catch(function (error) {
                if (error!=null){
                    console.info("ajax error:" + error);
                }
                try {
                    var dataObj = JSON.parse(error.responseText);
                } catch (error) {
                    var dataObj = error.responseText
                }
                if (dataObj != null && dataObj.status == 401) {//返回登录
                    StorageUtil.storeString("token", null);
                    StorageUtil.storeObject("user", null);
                    sessionStorage.clear();
                    if (dataObj.data.errorCode==30100) {
                        if (dataObj.data.message === '登录超时,请重新登录') {
                            store.wrap.$refs.repeat.isShow(0);
                            return;
                        }
                    }
                    return;
                }
                if (failCallback != null) {
                    failCallback(dataObj);
                } else {
                    if (dataObj == null) {
                        console.error("未知错误");
                    } else {
                        var exceptionResult = dataObj.data;
                        if (exceptionResult && exceptionResult.message != undefined && exceptionResult.message != null) {
                            console.error(exceptionResult.message);
                        } else {
                            console.error("未知错误:" + JSON.stringify(dataObj));
                        }
                    }
                }
            })
            .then(function (response) {
                if (typeof(response) == "undefined"){
                    console.error("未返回参数");
                    CommonUtil.setInfo("请求超时，请刷新重试");
                    return [];
                }
                if (response.data.status == 200) {//业务成功
                    if (successCallback == null) {
                        console.log("请求成功");
                    } else {
                        successCallback(response.data.data);
                    }
                } else {//业务失败
                    if (console) console.info("业务请求失败:" + response);
                    if (response.data.status != null && response.data.status == 401) {//返回登录
                        StorageUtil.storeString("token", null);
                        StorageUtil.storeObject("user", null);
                        /*sessionStorage.clear();*/
                        /*  return;*/
                    }
                    if (failCallback != null) {
                        failCallback(response.data.data);
                        if (response.data.data.errorCode == '30100') {
                            if (response.data.data.message === '登录超时,请重新登录') {
                                store.wrap.$refs.repeat.isShow(0);
                                return;
                            }
                            store.index.$refs.login.showLogin();
                        }
                    } else {
                        if (response.data.data.errorCode == '30100') {
                            if (response.data.data.message === '登录超时,请重新登录') {
                                store.wrap.$refs.repeat.isShow(0);
                                return;
                            }
                            store.index.$refs.login.showLogin();
                        }
                        if (response.data == null) {
                            console.error("未知错误");
                        } else {
                            var exceptionResult = response.data.data;
                            if (exceptionResult && exceptionResult.message != undefined && exceptionResult.message != null) {
                                console.error(exceptionResult.message);
                            } else {
                                console.error("未知错误---" );
                            }
                        }
                    }
                }
            })
    },

    /**
     * 用户是否超时判断
     */
    overtimeLogin:function (){
        if(store && store.func.getToken()==""){
            return;
        }
        if(store.wrap==null || store.wrap.$refs.repeat==null){
            return;
        }
        if(store.wrap.$refs.repeat.show){
            return;
        }
        if(CommonUtil.getCookie("noMovingTime")==""){
            this.ajaxLogout();
            store.wrap.$refs.repeat.isShow(1);
            return;
        }else{
            CommonUtil.setCookie("noMovingTime", "true", 0.125);
        }
        if(CommonUtil.getCookie("loginStart")=="") {
            this.ajaxLogout();
            store.wrap.$refs.repeat.isShow(2);
            return;
        }
    },
    ajaxLogin: function (url, data, method, successCallback, failCallback, thisStr) {
       // var baseUrl = 'http://' + location.host;
        let baseUrl = document.location.protocol+"//" + window.location.host;
        thisStr.axios({
            baseURL: baseUrl,
            url: encodeURI(url),
            method: method,
            data: JSON.stringify(data),
            responseType: 'json',
            headers: {
                token: store.func.getToken(),
                'Content-Type': 'application/json; charset=UTF-8',
            }
        })
            .catch(function (error) {
                console.info("loginError error:" + JSON.stringify(error));
                if (failCallback == null) {
                    console.error("登录失败");
                } else {
                    try {
                        var dataObj = JSON.parse(error.responseText);
                    } catch (error) {
                        var dataObj = error.responseText
                    }
                    failCallback(dataObj);
                }
            })
            .then(function (response) {
                if (response.data.status == 200) {//业务成功
                    if (successCallback == null) {
                    } else {
                        successCallback(response.data.data);
                    }
                } else {
                    if (failCallback == null) {
                    } else {
                        var dataObj = response.data.data;
                        failCallback(dataObj);
                    }
                }
            })
    },
    /**
     * 发送login请求，content-type: application/json
     * @param url     -rest api url    可以带参数
     * @param data    -提交的json数据  放入body中，如果无可以传空
     * @param method  - http请求类型
     */
    ajaxLogout: function () {
        StorageUtil.storeString("token", null);
        StorageUtil.storeObject("user", null);
        store.user=null;
        store.token="";
        store.wrap.user = null;
    },
};

export {ajaxUtil};
